(function () {
  const sections = document.querySelectorAll('[data-tea-process]');

  if (!sections.length) return;

  const colorGrid = [
    [
      [145, 195, 110],
      [195, 180, 105],
      [180, 145, 85],
      [130, 95, 60],
    ],
    [
      [175, 188, 95],
      [195, 170, 95],
      [175, 135, 75],
      [120, 85, 52],
    ],
    [
      [205, 170, 80],
      [198, 155, 78],
      [165, 118, 65],
      [110, 75, 45],
    ],
    [
      [195, 135, 65],
      [180, 118, 60],
      [145, 90, 50],
      [90, 58, 35],
    ],
    [
      [175, 95, 50],
      [158, 85, 48],
      [118, 65, 38],
      [62, 38, 22],
    ],
  ];

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function lerp(a, b, t) {
    return a + (b - a) * t;
  }

  function lerpColor(c1, c2, t) {
    return [
      Math.round(lerp(c1[0], c2[0], t)),
      Math.round(lerp(c1[1], c2[1], t)),
      Math.round(lerp(c1[2], c2[2], t)),
    ];
  }

  const oxidationTrackStops = [
    { pos: 0, color: [127, 164, 91] },
    { pos: 44, color: [195, 164, 82] },
    { pos: 72, color: [157, 90, 53] },
    { pos: 100, color: [75, 38, 24] },
  ];

  const roastTrackStops = [
    { pos: 0, color: [234, 223, 201] },
    { pos: 36, color: [202, 155, 85] },
    { pos: 68, color: [135, 83, 49] },
    { pos: 100, color: [36, 18, 11] },
  ];

  function sampleTrack(stops, value) {
    if (value <= stops[0].pos) return stops[0].color;
    if (value >= stops[stops.length - 1].pos) return stops[stops.length - 1].color;

    for (let i = 0; i < stops.length - 1; i++) {
      const a = stops[i];
      const b = stops[i + 1];

      if (value >= a.pos && value <= b.pos) {
        return lerpColor(a.color, b.color, (value - a.pos) / (b.pos - a.pos));
      }
    }

    return stops[stops.length - 1].color;
  }

  function getGridColor(oxidation, roast) {
    const ox = oxidation / 100;
    const ro = roast / 100;
    const rows = colorGrid.length - 1;
    const cols = colorGrid[0].length - 1;
    const oxIndex = Math.min(Math.floor(ox * rows), rows - 1);
    const roastIndex = Math.min(Math.floor(ro * cols), cols - 1);
    const oxProgress = ox * rows - oxIndex;
    const roastProgress = ro * cols - roastIndex;
    const topLeft = colorGrid[oxIndex][roastIndex];
    const topRight = colorGrid[oxIndex][roastIndex + 1];
    const bottomLeft = colorGrid[oxIndex + 1][roastIndex];
    const bottomRight = colorGrid[oxIndex + 1][roastIndex + 1];
    const top = lerpColor(topLeft, topRight, roastProgress);
    const bottom = lerpColor(bottomLeft, bottomRight, roastProgress);

    return lerpColor(top, bottom, oxProgress);
  }

  function getLabel(oxidation, roast) {
    const ox = oxidation / 100;
    const ro = roast / 100;

    if (ox < 0.08) {
      if (ro > 0.7) return 'Roasted green (hojicha territory)';
      if (ro > 0.35) return 'Roasted green tea';
      return 'Fixed green tea';
    }

    if (ox < 0.3) {
      if (ro < 0.15) return 'Lightly oxidized — white tea or green oolong';
      if (ro < 0.35) return 'Lightly oxidized, lightly roasted oolong';
      if (ro < 0.65) return 'Lightly oxidized, medium-roasted oolong';
      return 'Lightly oxidized, heavily roasted oolong';
    }

    if (ox < 0.7) {
      if (ro < 0.15) return 'Partially oxidized oolong';
      if (ro < 0.35) return 'Partially oxidized, lightly roasted oolong';
      if (ro < 0.65) return 'Partially oxidized, medium-roasted oolong';
      return 'Partially oxidized, heavily roasted oolong';
    }

    if (ox < 0.95) {
      if (ro < 0.15) return 'Highly oxidized oolong';
      if (ro < 0.35) return 'Highly oxidized, lightly roasted oolong';
      if (ro < 0.65) return 'Highly oxidized, medium-roasted oolong';
      return 'Highly oxidized, deeply roasted oolong';
    }

    if (ro < 0.15) return 'Fully oxidized — black or red tea';
    if (ro < 0.35) return 'Fully oxidized, lightly fired';
    if (ro < 0.65) return 'Fully oxidized, medium roast';
    return 'Fully oxidized, heavy roast';
  }

  function getColorName(oxidation, roast) {
    const ox = oxidation / 100;
    const ro = roast / 100;

    if (ox < 0.1 && ro < 0.15) return 'Bright green';
    if (ox < 0.1 && ro < 0.45) return 'Toasted straw';
    if (ox < 0.1 && ro < 0.75) return 'Warm hazelnut';
    if (ox < 0.1) return 'Deep chestnut';
    if (ox < 0.3 && ro < 0.2) return 'Pale yellow-green';
    if (ox < 0.3 && ro < 0.5) return 'Pale golden';
    if (ox < 0.3 && ro < 0.75) return 'Golden amber';
    if (ox < 0.3) return 'Warm amber';
    if (ox < 0.5 && ro < 0.2) return 'Light amber';
    if (ox < 0.5 && ro < 0.55) return 'Tawny amber';
    if (ox < 0.5) return 'Deep bronze';
    if (ox < 0.75 && ro < 0.2) return 'Coppery amber';
    if (ox < 0.75 && ro < 0.55) return 'Russet';
    if (ox < 0.75) return 'Dark walnut';
    if (ro < 0.2) return 'Mahogany';
    if (ro < 0.55) return 'Dark mahogany';

    return 'Near black';
  }

  function getBodyLevel(oxidation, roast) {
    const body = oxidation * 0.56 + roast * 0.44;

    if (body < 18) return 'Light';
    if (body < 40) return 'Medium light';
    if (body < 62) return 'Medium';
    if (body < 82) return 'Full';

    return 'Very full';
  }

  function getFinishLevel(oxidation, roast) {
    const ox = oxidation / 100;
    const ro = roast / 100;

    if (ro > 0.82) return 'Charcoal';
    if (ro > 0.58) return 'Roasted';
    if (ro > 0.32) return ox > 0.65 ? 'Caramel' : 'Toasted grain';
    if (ox > 0.82) return 'Malty';
    if (ox > 0.45) return 'Fruity';
    if (ox > 0.16) return 'Floral honey';

    return 'Fresh';
  }

  function getFlavorText(oxidation, roast) {
    const ox = oxidation / 100;
    const ro = roast / 100;

    if (ox < 0.1 && ro < 0.1) return 'Grassy, vegetal, fresh spring sweetness.';
    if (ox < 0.1 && ro < 0.45) return 'Toasted grain over a fresh green base, mild sweetness.';
    if (ox < 0.1) return 'Deep roast, toasted grain, smoke, and a soft finish.';
    if (ox < 0.3 && ro < 0.2) return 'Delicate florals, hay, honeydew, and light sweetness.';
    if (ox < 0.3 && ro < 0.5) return 'Fresh florals with a light roasted edge and soft honey.';
    if (ox < 0.3 && ro < 0.75) return 'Florals remain, with warm roasted grain, nuts, and baked-sweet notes.';
    if (ox < 0.3) return 'Florals muted by heavy roast — toast, caramel, and dry warmth lead.';
    if (ox < 0.55 && ro < 0.2) return 'Orchid, cream, fresh fruit, and lingering sweetness.';
    if (ox < 0.55 && ro < 0.55) return 'Roasted orchid, caramel, stone fruit, and warming grain.';
    if (ox < 0.55) return 'Deep caramel, charcoal, dried fruit, and mineral finish.';
    if (ox < 0.8 && ro < 0.2) return 'Stone fruit, honey, cocoa nib, and a brisk structure.';
    if (ox < 0.8 && ro < 0.55) return 'Toasty malt, dark chocolate, baked fruit, and wood.';
    if (ox < 0.8) return 'Smoke, dark chocolate, molasses, and a long warm finish.';
    if (ro < 0.2) return 'Malt, dried fruit, brisk tannin, and a clean finish.';
    if (ro < 0.55) return 'Malt with toast, caramel, and fuller body.';
    if (ro < 0.78) return 'Dark roast, smoky malt, brown sugar, and depth.';

    return 'Intense char, burnt caramel, smoke, and bold warmth.';
  }

  function setStageState(stageContainer, value) {
    if (!stageContainer) return;

    const stages = Array.from(stageContainer.querySelectorAll('.tea-process__stage'));
    const count = stages.length;
    const thresholds = stages.map((stage) => Number.parseFloat(stage.dataset.stageMax));
    const useThresholds = thresholds.every((t) => !Number.isNaN(t));

    let currentIndex;

    if (useThresholds) {
      currentIndex = thresholds.findIndex((max) => value <= max);
      if (currentIndex === -1) currentIndex = count - 1;

      let prev = 0;
      const columns = thresholds
        .map((max) => {
          const width = Math.max(max - prev, 0.0001);
          prev = max;
          return `${width}fr`;
        })
        .join(' ');
      stageContainer.style.setProperty('--stage-columns', columns);
    } else {
      currentIndex = Math.min(Math.floor(value / (100 / count)), count - 1);
      stageContainer.style.removeProperty('--stage-columns');
    }

    stageContainer.style.setProperty('--stage-count', count);

    stages.forEach((stage, index) => {
      stage.classList.toggle('is-active', index <= currentIndex);
      stage.classList.toggle('is-current', index === currentIndex);
    });
  }

  function animateSlider(slider, target, update) {
    const start = Number.parseInt(slider.value, 10);
    const end = clamp(target, 0, 100);

    if (prefersReducedMotion || start === end) {
      slider.value = end;
      update();
      return;
    }

    const difference = end - start;
    const duration = 420;
    const startedAt = window.performance.now();

    function tick(now) {
      const elapsed = now - startedAt;
      const progress = Math.min(elapsed / duration, 1);
      const eased = progress < 0.5
        ? 2 * progress * progress
        : -1 + (4 - 2 * progress) * progress;

      slider.value = Math.round(start + difference * eased);
      update();

      if (progress < 1) {
        window.requestAnimationFrame(tick);
      }
    }

    window.requestAnimationFrame(tick);
  }

  sections.forEach((section) => {
    if (section.dataset.teaProcessInitialized === 'true') return;

    section.dataset.teaProcessInitialized = 'true';

    const oxidationSlider = section.querySelector('[data-oxidation-slider]');
    const roastSlider = section.querySelector('[data-roast-slider]');
    const specimen = section.querySelector('[data-specimen]');
    const liquorStopLight = section.querySelector('[data-liquor-stop="light"]');
    const liquorStopMid = section.querySelector('[data-liquor-stop="mid"]');
    const liquorStopDark = section.querySelector('[data-liquor-stop="dark"]');
    const specimenLabel = section.querySelector('[data-specimen-label]');
    const oxidationValue = section.querySelector('[data-ox-value]');
    const roastValue = section.querySelector('[data-roast-value]');
    const colorName = section.querySelector('[data-color-name]');
    const bodyLevel = section.querySelector('[data-body-level]');
    const finishLevel = section.querySelector('[data-finish-level]');
    const flavorNotes = section.querySelector('[data-flavor-notes]');
    const oxidationStages = section.querySelector('[data-ox-stages]');
    const roastStages = section.querySelector('[data-roast-stages]');
    const presetButtons = Array.from(section.querySelectorAll('[data-preset]'));

    if (!oxidationSlider || !roastSlider || !specimen) return;

    function update() {
      const oxidation = clamp(Number.parseInt(oxidationSlider.value, 10) || 0, 0, 100);
      const roast = clamp(Number.parseInt(roastSlider.value, 10) || 0, 0, 100);
      const base = getGridColor(oxidation, roast);
      const light = [
        clamp(base[0] + 36, 0, 255),
        clamp(base[1] + 26, 0, 255),
        clamp(base[2] + 16, 0, 255),
      ];
      const deep = [
        clamp(base[0] - 16, 0, 255),
        clamp(base[1] - 12, 0, 255),
        clamp(base[2] - 8, 0, 255),
      ];

      const lightColor = `rgb(${light.join(', ')})`;
      const baseColor = `rgb(${base.join(', ')})`;
      const deepColor = `rgb(${deep.join(', ')})`;

      if (liquorStopLight) liquorStopLight.setAttribute('stop-color', lightColor);
      if (liquorStopMid) liquorStopMid.setAttribute('stop-color', baseColor);
      if (liquorStopDark) liquorStopDark.setAttribute('stop-color', deepColor);

      const oxThumb = sampleTrack(oxidationTrackStops, oxidation);
      const roastThumb = sampleTrack(roastTrackStops, roast);
      oxidationSlider.style.setProperty('--tea-slider-thumb', `rgb(${oxThumb.join(', ')})`);
      roastSlider.style.setProperty('--tea-slider-thumb', `rgb(${roastThumb.join(', ')})`);

      if (oxidationValue) oxidationValue.textContent = `${oxidation}%`;
      if (roastValue) roastValue.textContent = `${roast}%`;
      if (specimenLabel) specimenLabel.textContent = getLabel(oxidation, roast);
      if (colorName) colorName.textContent = getColorName(oxidation, roast);
      if (bodyLevel) bodyLevel.textContent = getBodyLevel(oxidation, roast);
      if (finishLevel) finishLevel.textContent = getFinishLevel(oxidation, roast);
      if (flavorNotes) flavorNotes.textContent = getFlavorText(oxidation, roast);

      setStageState(oxidationStages, oxidation);
      setStageState(roastStages, roast);

      presetButtons.forEach((button) => {
        const presetOx = Number.parseInt(button.dataset.ox, 10);
        const presetRoast = Number.parseInt(button.dataset.roast, 10);
        const isActive = Math.abs(presetOx - oxidation) < 4 && Math.abs(presetRoast - roast) < 4;

        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });
    }

    oxidationSlider.addEventListener('input', update);
    roastSlider.addEventListener('input', update);

    presetButtons.forEach((button) => {
      button.setAttribute('aria-pressed', 'false');

      button.addEventListener('click', () => {
        const targetOx = Number.parseInt(button.dataset.ox, 10);
        const targetRoast = Number.parseInt(button.dataset.roast, 10);

        animateSlider(oxidationSlider, targetOx, update);
        animateSlider(roastSlider, targetRoast, update);
      });
    });

    update();
  });
})();
